import React from 'react'

import { HeaderMenu, PrimaryButton } from '../../components'
import { LinkIcon, LogoIcon } from '../../screenshots'
import { scrollToTariffs } from '../../utils'

const INFO_PAGES = ['/oferta', '/pers', '/about']

const SiteHeader = ({ setShowConnectUsModal, url }) => {
  const isInfoPage = INFO_PAGES.includes(url)
  const isParsingPage = url === '/parsing'

  const openConnectUsModal = () => {
    setShowConnectUsModal(true)
    document.querySelector('body').style.overflow = 'hidden'
    document.querySelector('body').classList.add('disabled-scroll')
    document.querySelector('html').style.overflow = 'hidden'
  }

  return (
    <div className="flex justify-between pt-5 mx-5 lg:mx-10 lg:pt-10 items-center">
      <div className="flex items-center">
        <div className="flex items-center">
          <a href="/" className="flex items-center cursor-pointer">
            <div className="text-white block">
              <LogoIcon />
            </div>
            <span className="hidden lg:block ml-3 text-white text-[26px] font-semibold leading-[35px]">
              {'Прайс Ниндзя'.toUpperCase()}
            </span>
          </a>
          <div className="lg:hidden ml-2 flex items-center">
            <span className="block text-white text-[14px] font-semibold leading-[17px]">
              {'Прайс Ниндзя'.toUpperCase()}
            </span>
          </div>
        </div>
        <div className="hidden lg:block">
          <HeaderMenu currentUrl={url} />
        </div>
      </div>

      {!isInfoPage && (
        <>
          {!isParsingPage ?
            <div className="flex space-x-2 lg:space-x-3">
              <PrimaryButton
                className="px-5 py-2.5 lg:px-8 lg:py-4 hidden lg:flex items-center justify-center bg-[rgb(26,41,55,0.65)]"
                onClick={event => {
                  event.preventDefault()
                  scrollToTariffs()
                }}
                style={{ backdropFilter: 'blur(7.5px)' }}
              >
                <span className="text-white font-semibold text-xs leading-[14px] lg:text-xl lg:leading-6">
                  Тарифы
                </span>
              </PrimaryButton>
              <PrimaryButton
                className="px-5 py-2.5 lg:px-8 lg:py-4 hidden lg:flex items-center justify-center"
                onClick={() =>
                  (window.location.href = 'https://go.priceninja.ru/products')
                }
              >
                <span className="text-white font-semibold text-xs leading-[14px] lg:text-xl lg:leading-6">
                  Войти
                </span>
              </PrimaryButton>
              <a href="/parsing" className="flex lg:hidden items-center">
                <span className="block text-white text-[14px] leading-[17px] mr-1 font-semibold">
                  Парсинг
                </span>
                <LinkIcon />
              </a>
            </div>
          : <div>
              <PrimaryButton
                className="px-5 py-2.5 lg:px-8 lg:py-4 hidden lg:flex items-center justify-center"
                onClick={openConnectUsModal}
              >
                <span className="block text-white font-semibold text-xs leading-[14px] lg:text-xl lg:leading-6">
                  Связаться
                </span>
              </PrimaryButton>
              <a href="/" className="flex lg:hidden items-center">
                <span className="block text-white text-[14px] leading-[17px] mr-1 font-semibold">
                  Мониторинг
                </span>
                <LinkIcon />
              </a>
            </div>
          }
        </>
      )}
    </div>
  )
}

export { SiteHeader }
